export default __webpack_public_path__ + "static/media/logo_Salud-Para-Todos.7b414e25.png";